import React, { useEffect, useState } from "react";

import Rodape from "../../components/Footer/rodape";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { DashLayoutGridAtualizarPerfil } from "../../components/DashLayoutGridAtualizarPerfil";

import CircularProgress from "@mui/material/CircularProgress";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

export const AtualizarPerfil = () => {
  const _data = JSON.parse(sessionStorage.getItem("@Auth:data"));

  const [username, setUserName] = useState("");
  const [matricula, setMatricula] = useState("");
  const [email, setEmail] = useState("");
  const [emailperso, setEmailperso] = useState("");
  const [telefone, setTelefone] = useState("");
  const [telefonesector, setTelefonesector] = useState("");
  const [unidwork, setUnidwork] = useState("");
  const [funcao, setFuncao] = useState("");
  const [graduacao, setGraduacao] = useState("");
  const [posgraduacao, setPosgraduacao] = useState("");
  const [mestrado, setMestrado] = useState("");
  const [doutorado, setDoutorado] = useState("");

  const [isLoading, setIsLoading] = useState(true);

  /*   const InscricaoOk = () =>
    toast.success("Atualização cadastrada com sucesso.", {
      position: "top-center",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    }); */

  const matriError = () =>
    toast.info("Ops!, Insira a matricula", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const emailError = () =>
    toast.info("Ops!, email", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const telefoneError = () =>
    toast.info("Ops!, telefone pessoal", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const telefonesectorError = () =>
    toast.info("Ops!, telefone setor", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const UnidError = () =>
    toast.info("Ops!, unidade de trabalho", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const funcaoError = () =>
    toast.info("Ops!, função", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const graduError = () =>
    toast.info("Ops!, graduacao", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const posGraError = () =>
    toast.info("Ops!, pós-graduação", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const mestrError = () =>
    toast.info("Ops!, mestrado", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const doutError = () =>
    toast.info("Ops!, doutorado", {
      position: "top-right",
      autoClose: 5500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const handleSubmitPerfil = async (e) => {
    e.preventDefault();
    if (!matricula) {
      matriError();
      return;
    }

    if (!emailperso) {
      emailError();
      return;
    }

    if (!telefone) {
      telefoneError();
      return;
    }

    if (!telefonesector) {
      telefonesectorError();
      return;
    }

    if (!unidwork) {
      UnidError();
      return;
    }

    if (!funcao) {
      funcaoError();
      return;
    }

    if (!graduacao) {
      graduError();
      return;
    }
    if (!posgraduacao) {
      posGraError();
      return;
    }
    if (!mestrado) {
      mestrError();
      return;
    }
    if (!doutorado) {
      doutError();
      return;
    }
  };

  return (
    <>
      <Header />
      <Menu />
      <DashLayoutGridAtualizarPerfil>
        <h3 style={{ color: "#ccc" }}>ATUALIZAÇÃO CADASTRAL</h3>
        <hr style={{ color: "#ccc" }} />
        {isLoading !== true ? (
          <>
            <br />{" "}
            <center>
              <h4 style={{ color: "#568989" }}>Carregando.... </h4>
              <br />
              <CircularProgress />
            </center>
          </>
        ) : (
          <>
            <form onSubmit={handleSubmitPerfil} className="login-form">
              <span
                className="login-form-title"
                style={{ marginTop: "-50px" }}
              ></span>

              <br />
              <br />
              <br />
              <br />
              <div className="wrap-input">
                <input
                  className={username !== "" ? "has-val input-atual" : "input"}
                  type="text"
                  value={_data.nome}
                  disabled
                  onChange={(e) => setUserName(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Nome"
                ></span>
                   
              </div>
 <br />
              <div className="wrap-input">
                <input
                  className={matricula !== "" ? "has-val input" : "input"}
                  type="number"
                  value={matricula}
                  onChange={(e) => setMatricula(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Matricula"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={email !== "" ? "has-val input" : "input"}
                  type="email"
                  value={_data.email}
                  disabled
                  onChange={(e) => setEmail(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="E-mail institucional:"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={emailperso !== "" ? "has-val input" : "input"}
                  type="email"
                  value={emailperso}
                  onChange={(e) => setEmailperso(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="E-mail pessoal:"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={telefone !== "" ? "has-val input" : "input"}
                  type="number"
                  value={telefone}
                  onChange={(e) => setTelefone(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Telefone pessoal:"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={telefonesector !== "" ? "has-val input" : "input"}
                  type="number"
                  value={telefonesector}
                  onChange={(e) => setTelefonesector(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Telefone do setor:"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={unidwork !== "" ? "has-val input" : "input"}
                  type="text"
                  value={unidwork}
                  onChange={(e) => setUnidwork(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Unidade de Trabalho:"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={funcao !== "" ? "has-val input" : "input"}
                  type="text"
                  value={funcao}
                  onChange={(e) => setFuncao(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Cargo/Função"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={graduacao !== "" ? "has-val input" : "input"}
                  type="text"
                  value={graduacao}
                  onChange={(e) => setGraduacao(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Superior:"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={posgraduacao !== "" ? "has-val input" : "input"}
                  type="text"
                  value={posgraduacao}
                  onChange={(e) => setPosgraduacao(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Pós-graduação:"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={mestrado !== "" ? "has-val input" : "input"}
                  type="text"
                  value={mestrado}
                  onChange={(e) => setMestrado(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Mestrado:"
                ></span>
              </div>
              <br />
              <div className="wrap-input">
                <input
                  className={doutorado !== "" ? "has-val input" : "input"}
                  type="text"
                  value={doutorado}
                  onChange={(e) => setDoutorado(e.target.value)}
                />
                <span
                  className="focus-input-atual"
                  data-placeholder="Doutorado:"
                ></span>
              </div>

              <div className="container-login-form-btn">
                <button type="submit" className="login-form-btn">
                  Atualizar
                </button>
              </div>
              <ToastContainer />
              <br />
            </form>
            <ToastContainer />
          </>
        )}

        <br />
      </DashLayoutGridAtualizarPerfil>
      <Rodape />
    </>
  );
};
